import { Helmet } from '@vuer-ai/react-helmet-async'

import { SEOProps } from './SEO.types'

export const SEO = (props: SEOProps) => {
    const {
        title,
        description,
        keywords,
        canonical,
        ogType = 'website',
        ogImage,
        structuredData,
    } = props

    return (
        <Helmet>
            <title>{title}</title>
            <meta name='description' content={description}/>
            {keywords && <meta name='keywords' content={keywords}/>}

            <meta property='og:type' content={ogType}/>
            <meta property='og:title' content={title}/>
            <meta property='og:description' content={description}/>
            <meta property='og:site_name' content='Nexly'/>
            <meta property='og:locale' content='en_US'/>
            {ogImage && <meta property='og:image' content={ogImage}/>}

            <meta name='twitter:card' content='summary_large_image'/>
            <meta name='twitter:title' content={title}/>
            <meta name='twitter:description' content={description}/>
            {ogImage && <meta name='twitter:image' content={ogImage}/>}

            <meta name='robots' content='index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'/>
            {canonical && <link rel='canonical' href={canonical}/>}

            {structuredData && (
                <script type='application/ld+json'>
                    {JSON.stringify(structuredData)}
                </script>
            )}
        </Helmet>
    )
}
